/**
 * Animation utilities and configurations
 * Provides reusable animation settings and helpers
 */

export const ANIMATION_DURATION = {
	fast: 300,
	normal: 450,
	slow: 650,
} as const;

export const ANIMATION_EASING = {
	easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
	easeOut: 'cubic-bezier(0, 0, 0.2, 1)',
	easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
	smooth: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
} as const;

/**
 * Check if user prefers reduced motion
 */
export const prefersReducedMotion = (): boolean => {
	if (typeof window === 'undefined') return false;
	return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

/**
 * Get animation duration based on reduced motion preference
 */
export const getAnimationDuration = (duration: number = ANIMATION_DURATION.normal): number => {
	return prefersReducedMotion() ? 0 : duration;
};

/**
 * Stagger delay for grid items
 */
export const getStaggerDelay = (index: number, baseDelay: number = 50): number => {
	return prefersReducedMotion() ? 0 : index * baseDelay;
};
